module.exports = "../study/imgs/maps/Tokyo/GWQ8/Climate/FrontDay/Tokyo_FrontDay_MRI_RCP85_End.png";